import thunk from 'redux-thunk'
import { loginRequest, loginSuccess, loginFailed, getUserProfileRequest, getUserProfileSuccess, getUserProfileFailed } from './actions'
import axios from 'axios'
import keys from '../../../keys'





export const login = (server,data={},successCallback=()=>{},errorCallback=()=>{}) => {
    return dispatch => {
        dispatch(loginRequest())
        axios.post(`${server}/user/get-auth-token/`,data)
        .then(
            response => {
                dispatch(loginSuccess(response.data))
                if(data.remember){
                    window.localStorage.setItem("authData", JSON.stringify(response.data))
                }
                successCallback()
            }
        )
        .catch(
            error => {
                console.error(error)
                dispatch(loginFailed(error))
                errorCallback(error)
            }
        )
    }
}

export const getProfile = (server,token,successCallback=()=>{},errorCallback=()=>{}) => {
    return dispatch => {
        dispatch(getUserProfileRequest())
        axios.post(`${server}/user/get-user-profile/`,null,{headers:{Authorization:`Token ${token}`}})
        .then(
            response => {
                if(response.data.success){
                    dispatch(getUserProfileSuccess(response.data.data))
                    successCallback()
                }else{
                    throw Error(response.data.message)
                }   
            }
        )
        .catch(
            error => {
                dispatch(getUserProfileFailed(error))
                errorCallback()
            }
        )
    }
}
